import React, { FC, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { guids, paths } from '../Root/paths';

import ContentTabs from '../../components_/Content/ContentTabs';
import Tabbar from '../../components_/Tabbar';
import isSatisfied from '../../utils/isSatisfied';
import { Dispatch, iRootState } from '../../store';

const mapState = (state: iRootState) => ({
  rights: state.securable.data
});

const mapDispatch = (dispatch: Dispatch) => ({});

type ConnectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const Tabs: FC<ConnectedProps> = ({ rights }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const hasRightsToRoles = isSatisfied({ uid: guids.settings.secTree.roles.root, action: 'Visibility' }, rights);
  const hasRightsToRights = isSatisfied({ uid: guids.settings.secTree.rights.root, action: 'Visibility' }, rights);
  const hasRightsToProtectionTypes = isSatisfied({ uid: guids.settings.protectionTypes.root, action: 'Visibility' }, rights);
  const hasRightsToConfig = isSatisfied({ uid: guids.settings.config.root, action: 'Visibility' }, rights);

  const tabs = useMemo(() => {
    const result: Array<{ name: string; url: string; uid?: string }> = [
      {
        name: 'Шаблоны уведомлений',
        url: paths.settings.root,
        uid: guids.settings.root
      }
    ];

    // Скрываем "Типы экипировки" если нет прав
    if (hasRightsToProtectionTypes) {
      result.push({
        name: 'Типы экипировки',
        url: paths.settings.protectionTypes.root,
        uid: guids.settings.protectionTypes.root
      });
    }

    // Показываем "Роли и доступы" только если есть права на роли
    // Если есть права только на доступы - показываем вкладку "Доступы"
    if (hasRightsToRoles) {
      result.push({
        name: 'Роли и доступы',
        url: paths.settings.secTree.roles.root,
        uid: guids.settings.secTree.roles.root
      });
    } else if (hasRightsToRights) {
      result.push({
        name: 'Доступы',
        url: paths.settings.secTree.rights.root,
        uid: guids.settings.secTree.rights.root
      });
    }

    // Скрываем "Конфигурация" если нет прав
    if (hasRightsToConfig) {
      result.push({
        name: 'Конфигурация',
        url: paths.settings.config.root,
        uid: guids.settings.config.root
      });
    }

    // "Настройки сервисов" доступна всем авторизованным: эндпоинты сервисов
    // не проверяют права, только валидность JWT
    result.push({
      name: 'Настройки сервисов',
      url: paths.settings.services.root
    });

    return result;
  }, [hasRightsToRoles, hasRightsToRights, hasRightsToProtectionTypes, hasRightsToConfig]);

  const isOnRoles = pathname === paths.settings.secTree.roles.root;
  const isOnRights = pathname === paths.settings.secTree.rights.root;

  useEffect(() => {
    // Если мы на странице ролей, но нет прав на роли, и есть права на доступы - редирект на доступы
    if (isOnRoles && !hasRightsToRoles && hasRightsToRights) {
      history.replace(paths.settings.secTree.rights.root);
    }
    // Если мы на странице доступов, но нет прав на доступы - редирект на главную настроек
    if (isOnRights && !hasRightsToRights) {
      history.replace(paths.settings.root);
    }
  }, [isOnRoles, isOnRights, hasRightsToRoles, hasRightsToRights, pathname, history]);

  return (
    <ContentTabs>
      <Tabbar tabs={tabs} />
    </ContentTabs>
  );
};

export default connect(mapState, mapDispatch)(Tabs);
